import React, { useEffect } from 'react'

const Logout = () => {

    useEffect(() => {
        // Clear localStorage FIRST (synchronous), then navigate
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('Club_id');
        localStorage.removeItem('permission');
        localStorage.removeItem('userData');

        // Navigate after cleanup is complete
        window.location.href = "/signin";
    }, [])


  return (
    <div style={{minHeight:'100vh'}}></div>
  )
}

export default Logout